var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"margin":"10px"}},[_vm._m(0),_c('basic-chart-output',{ref:'playback',staticStyle:{"border":"1px solid darkgray"},attrs:{"windowHeight":'700',"namespace":_vm.namespace}})],1)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h1',{staticClass:"text-2xl"},[_vm._v("Playback")])])
}]

export { render, staticRenderFns }